import {
  NotificationService,
  OuiBoxComponent,
  OuiButtonComponent,
  OuiCenterComponent,
  OuiRecordDatasource as OuiDatasource,
  OuiGridComponent,
  OuiStackComponent,
  OuiTextComponent,
} from '@aiz-gl/omni-ui';
import { Component, effect, inject } from '@angular/core';
import { DownloadButtonComponent } from '../../components/download-button/download-button.component';
import { LogTableComponent } from '../../components/log-table/log-table.component';
import { PageComponent } from '../../components/page/page';
import { SyncResponse } from '../../models/product.models';
import { WorkflowLogEntry } from '../../models/workflow-history.model';
import { ProductService } from '../../services/product/product.service';
import { BasePageComponent } from '../base/base.component';

@Component({
  selector: 'app-product',
  standalone: true,
  imports: [
    OuiStackComponent,
    OuiCenterComponent,
    OuiBoxComponent,
    OuiGridComponent,
    OuiTextComponent,
    OuiButtonComponent,
    DownloadButtonComponent,
    LogTableComponent,
    PageComponent,
  ],
  templateUrl: './product.component.html',
})
export class ProductPage extends BasePageComponent {
  permissionToSync = this.permissionTo('product:manage');
  private readonly notification = inject(NotificationService);
  protected readonly productService = inject(ProductService);

  dataSyncHistoryDatasource!: OuiDatasource<WorkflowLogEntry>;

  constructor() {
    super();

    // Even if the data sync history is Initialized, we want to refresh it on each page load.
    this.productService.dataSyncHistory.reload();

    effect(() => {
      const data = this.productService.dataSyncHistory.value();
      if (!data) return;
      this.dataSyncHistoryDatasource = new OuiDatasource(data);
    });
  }

  getProductCatalogFileName = this.productService.productCatalogFileName;

  synchronizeProductData() {
    this.productService.syncProductForUser().subscribe({
      next: (response: SyncResponse) => {
        if (response.results?.length > 0) {
          if (response.results.every((result) => result.success)) {
            this.notification.showSnackbar({
              message: `Sync completed successfully.`,
              variant: 'success',
              symbolName: 'check_circle',
            });
            return;
          }
          if (response.results.some((result) => !result.success)) {
            const errorMessages = response.results
              .map(
                (result) =>
                  result.error ||
                  'Failed to sync product. Please try again later.',
              )
              .join(', ');
            this.notification.showSnackbar({
              message: errorMessages,
              variant: 'warn',
              symbolName: 'error',
            });
            return;
          }
        } else {
          this.notification.showSnackbar({
            message: Array.isArray(response.errors)
              ? response.errors.join(', ')
              : response.errors ||
                'Failed to sync product. Please try again later.',
            variant: 'warn',
            symbolName: 'warning',
          });
        }
      },
      error: (err) => {
        this.notification.showSnackbar({
          message:
            err.error || 'Failed to sync product data. Please try again.',
          variant: 'warn',
          symbolName: 'error',
        });
      },
    });
  }
}
